module.exports = __webpack_public_path__ + "static/media/icon_logout.e8e62f9b.svg";